import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import config from '../../config'
import { loginUser } from '../../ducks/auth'
import routes from '../../routes'
import { LoginPageStyle } from './styled'

export const LoginPage = () => {
  const [email, setEmail] = useState('')

  const { isFetching, isAuthenticated } = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  const handleLogin = (e) => {
    e.preventDefault()
    loginUser(dispatch, {
      email,
    })
  }

  const onEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }

  useEffect(() => {
    document.title = `${config.eventName} | Login`
  }, [])

  if (isAuthenticated) {
    return <Redirect to={routes.lobby} />
  } else {
    return (
      <LoginPageStyle>
        <>
          <form onSubmit={handleLogin}>
            <p className="title">LOGIN</p>
            <input type="email" placeholder="Email Address" value={email} onChange={onEmailInput} />
            {/* <input type="password" value={password} placeholder="Password" onChange={onPasswordInput} /> */}

            <div className="btn login-btn" onClick={handleLogin} style={{ background: isFetching ? 'lightgray' : 'linear-gradient(#da2a3a, #ac1723)' }}>
              <input disabled={!email.length || isFetching} type="submit" value={isFetching ? '' : ''} />
              SUBMIT
            </div>
          </form>
        </>
      </LoginPageStyle>
    )
  }
}
